import TextPreview from './TextPreview';
import './TextPreview.scss';

export default TextPreview;
